var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLaunching(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 326,
    viewBox: "0 0 326 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 163,
    cy: 163,
    r: 163,
    fill: "#E4E4E4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 162.5,
    r: 122.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163 19.6545C163 8.7996 171.831 -0.122302 182.607 1.1834C210.071 4.51116 236.353 14.7917 258.897 31.1944C286.762 51.4679 307.485 80.0507 318.09 112.838C328.694 145.625 328.635 180.93 317.921 213.681C309.252 240.179 293.969 263.903 273.656 282.684C265.686 290.053 253.302 287.993 246.946 279.194V279.194C240.589 270.395 242.706 258.207 250.388 250.538C264.103 236.846 274.478 220.052 280.56 201.459C288.691 176.606 288.736 149.815 280.688 124.935C272.641 100.055 256.916 78.3648 235.771 62.9805C219.952 51.4711 201.708 43.9338 182.572 40.8671C171.854 39.1495 163 30.5093 163 19.6545V19.6545Z",
    fill: "#0049C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLaunching);
export default __webpack_public_path__ + "static/media/icon-launching.94bac1bb1fe85d5fba3564e865fc6ba3.svg";
export { ForwardRef as ReactComponent };